import { render, staticRenderFns } from "./WeChatBind.vue?vue&type=template&id=451799cf&scoped=true&"
import script from "./WeChatBind.vue?vue&type=script&lang=js&"
export * from "./WeChatBind.vue?vue&type=script&lang=js&"
import style0 from "./WeChatBind.vue?vue&type=style&index=0&id=451799cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451799cf",
  null
  
)

export default component.exports